import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'keys',
pure: true
})
export class KeysPipe implements PipeTransform {
  transform(value, args:string[]) : any {
    let keys = [];
    for (let key in value) {
      if(value[key]){
        keys.push({key: key, value: value[key]});
      }
    }
    return keys;
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/keys.pipe.ts